webpackJsonp([66192783228365],{

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconPlay = __webpack_require__(49);
	
	var _IconPlay2 = _interopRequireDefault(_IconPlay);
	
	var _IconPause = __webpack_require__(48);
	
	var _IconPause2 = _interopRequireDefault(_IconPause);
	
	var _IconRestart = __webpack_require__(50);
	
	var _IconRestart2 = _interopRequireDefault(_IconRestart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "div",
	    { id: "TLcontrols", className: "animation-controls" },
	    _react2.default.createElement(
	      "div",
	      { className: "buttons" },
	      _react2.default.createElement(
	        "button",
	        {
	          className: "play btn draw-border " + (props.color ? props.color : null),
	          "aria-label": "play animation"
	        },
	        _react2.default.createElement(_IconPlay2.default, { color: props.color })
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "pause btn draw-border " + (props.color ? props.color : null),
	          "aria-label": "pause animation"
	
	        },
	        _react2.default.createElement(_IconPause2.default, { color: props.color })
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "restart btn draw-border " + (props.color ? props.color : null),
	          "aria-label": "restart animation"
	        },
	        _react2.default.createElement(_IconRestart2.default, { color: props.color })
	      )
	    ),
	    _react2.default.createElement("input", {
	      className: props.color ? props.color + " progress" : "progress",
	      "aria-label": "seek animation",
	      step: "1",
	      type: "range",
	      min: "0",
	      max: "100"
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: props.width ? props.width : "24",
	      height: props.height ? props.height : "24",
	      viewBox: "0 0 24 24"
	    },
	    _react2.default.createElement("path", { className: props.color ? props.color : null, d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z" }),
	    _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: props.width ? props.width : "24",
	      height: props.height ? props.height : "24",
	      viewBox: "0 0 24 24"
	    },
	    _react2.default.createElement("path", { className: props.color ? props.color : null, d: "M8 5v14l11-7z" }),
	    _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: props.width ? props.width : "24",
	      height: props.height ? props.height : "24",
	      viewBox: "0 0 24 24"
	    },
	    _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	    _react2.default.createElement("path", { className: props.color ? props.color : null, d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "text",
	    {
	      id: props.id ? props.id : null,
	      className: "heading heading-center",
	      xmlSpace: "preserve",
	      textAnchor: "middle",
	      y: "122",
	      x: "390",
	      strokeWidth: "0",
	      stroke: "null",
	      fill: props.color ? props.color : "white",
	      style: {
	        fontSize: props.fontSize ? props.fontSize : '45px'
	      }
	    },
	    props.content
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "g",
	    {
	      className: "text-list",
	      transform: "translate(361)",
	      id: props.id ? props.id : null
	    },
	    props.list && props.list.map(function (item, index) {
	      return _react2.default.createElement(
	        "text",
	        {
	          key: index,
	          className: "list-item",
	          xmlSpace: "preserve",
	          textAnchor: "middle",
	          y: 180 + index * 40,
	          x: "30",
	          strokeWidth: "0",
	          stroke: "null",
	          fill: props.color ? props.color : "white",
	          style: {
	            fontSize: props.fontSize ? props.fontSize : "20px"
	          }
	        },
	        item
	      );
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Taken from https://codepen.io/tmrDevelops/pen/yyprGq
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "g",
	    { transform: "translate(60)", className: "typing-text-wrapper" },
	    _react2.default.createElement("path", { id: "typing-text-path-" + props.number, d: "m0,110 h0" }),
	    _react2.default.createElement(
	      "text",
	      {
	        fontSize: props.fontSize ? props.fontSize : "20px",
	        id: "typing-text-" + props.number,
	        fill: props.color ? props.color : "white"
	      },
	      _react2.default.createElement(
	        "textPath",
	        { xlinkHref: "#typing-text-path-" + props.number },
	        props.content
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animejs = __webpack_require__(22);
	
	var _animejs2 = _interopRequireDefault(_animejs);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SVG = __webpack_require__(51);
	
	var _SVG2 = _interopRequireDefault(_SVG);
	
	var _Menu = __webpack_require__(70);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Flower = __webpack_require__(46);
	
	var _Flower2 = _interopRequireDefault(_Flower);
	
	var _animations = __webpack_require__(54);
	
	var _reactRouterDom = __webpack_require__(20);
	
	var _Heading = __webpack_require__(91);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _TextList = __webpack_require__(52);
	
	var _TextList2 = _interopRequireDefault(_TextList);
	
	var _TypingText = __webpack_require__(53);
	
	var _TypingText2 = _interopRequireDefault(_TypingText);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Logo = __webpack_require__(26);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _AnimationControls = __webpack_require__(45);
	
	var _AnimationControls2 = _interopRequireDefault(_AnimationControls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nip = function (_Component) {
	  _inherits(Nip, _Component);
	
	  function Nip() {
	    _classCallCheck(this, Nip);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this._isMounted = false; // Not an optimal solution.
	    _this.handleMenuClick = _this.handleMenuClick.bind(_this);
	    _this.state = {
	      redirect: false
	    };
	    return _this;
	  }
	
	  Nip.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	
	    var controlsProgressEl = document.querySelector("#TLcontrols .progress");
	
	    // Flower main screen animations.
	    document.querySelector("#real-flower").style.display = "none";
	    (0, _animejs2.default)((0, _animations.scaleUp)("#petal-nip-dupli", [1, 10], 1000));
	    (0, _animejs2.default)((0, _animations.translateY)("header", [0, -100]));
	    (0, _animejs2.default)((0, _animations.fadeIn)("#TLcontrols", 1000));
	
	    // Text animations.
	    var controlledTimeline = _animejs2.default.timeline({
	      easing: "linear",
	      update: function update(anim) {
	        return controlsProgressEl.value = anim.progress;
	      }
	    }).add((0, _animations.fadeInFromLeftAndRight)("#heading-paixnidi", 200, 1500)).add((0, _animations.fadeInFromLeftAndRight)("#list-paixnidi .list-item", 500, 1500)).add((0, _animations.fadeOut)("#heading-paixnidi", 1500)).add((0, _animations.fadeOutList)("#list-paixnidi .list-item", 0, 200)).add((0, _animations.fadeInFromLeftAndRight)("#heading-taxidi", 200, 1500)).add((0, _animations.fadeInFromLeftAndRight)("#list-taxidi .list-item", 500, 2000)).add((0, _animations.fadeOut)("#heading-taxidi", 1500)).add((0, _animations.fadeOutList)("#list-taxidi .list-item", 0, 200)).add((0, _animations.typing)("#typing-text-path-1", ["m-8,180 h0", "m-8,180 h700"], 5000)).add((0, _animations.typing)("#typing-text-path-2", ["m130,230 h0", "m130,230 h450"], 2000)).add((0, _animations.fadeInFromRight)("#animated-logo"));
	
	    document.querySelector("#TLcontrols .play").onclick = controlledTimeline.play;
	    document.querySelector("#TLcontrols .pause").onclick = controlledTimeline.pause;
	    document.querySelector("#TLcontrols .restart").onclick = controlledTimeline.restart;
	
	    controlsProgressEl.addEventListener("input", function () {
	      return controlledTimeline.seek(controlledTimeline.duration * (controlsProgressEl.value / 100));
	    });
	
	    ["input", "change"].forEach(function (evt) {
	      return controlsProgressEl.addEventListener(evt, function () {
	        return controlledTimeline.seek(controlledTimeline.duration * (controlsProgressEl.value / 100));
	      });
	    });
	  };
	
	  Nip.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	  };
	
	  Nip.prototype.handleMenuClick = function handleMenuClick() {
	    if (this._isMounted) this.setState({ redirect: true });
	  };
	
	  Nip.prototype.render = function render() {
	    if (this.state.redirect) return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: "/", state: { referrer: "/Nip", elementId: '#petal-nip-dupli' } } });
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "Όνειρο - Νηπιαγωγείο",
	        meta: [{ name: 'description', content: "Όνειρο - σελίδα Νηπιαγωγείου. Το Νηπιαγωγείο είναι αγάπη, εμπιστοσύνη, ασφάλεια, χαρά. Το Νηπιαγωγείο είναι 'Όνειρο'. " }]
	      }),
	      _react2.default.createElement(
	        _Header2.default,
	        null,
	        _react2.default.createElement(
	          _SVG2.default,
	          {
	            id: "header-logo",
	            height: "48px",
	            width: "350px",
	            viewBox: "20 0 220 150"
	          },
	          _react2.default.createElement(_Logo2.default, null)
	        )
	      ),
	      _react2.default.createElement(_Menu2.default, { color: "#550055", handleMenuClick: this.handleMenuClick }),
	      _react2.default.createElement(
	        "main",
	        null,
	        _react2.default.createElement(
	          _SVG2.default,
	          { id: "flower", viewBox: "50 -40 680 700", fitToScreen: true },
	          _react2.default.createElement(_Flower2.default, { page: "Nip" }),
	          _react2.default.createElement(_Heading2.default, {
	            id: "heading-paixnidi",
	            content: "Το Νηπιαγωγείο είναι παιχνίδι",
	            color: "#550055",
	            fontSize: "35px"
	          }),
	          _react2.default.createElement(_TextList2.default, {
	            id: "list-paixnidi",
	            fontSize: "25px",
	            list: ["Παιχνίδι συνύπαρξης, συνεργασίας, φιλίας", "Παιχνίδι σκέψης", "Παιχνίδι γνώσης", "Παιχνίδι αναγνώρισης έκφρασης συναισθημάτων", "Παιχνίδι κίνησης", "Παιχνίδι δημιουργίας", "Παιχνίδι καλλιέργειας δεξιοτήτων", "Παιχνίδι αγωγής..."],
	            color: "#550055"
	          }),
	          _react2.default.createElement(_Heading2.default, {
	            id: "heading-taxidi",
	            content: "Το νηπιαγωγείο είναι ταξίδι",
	            color: "#550055",
	            fontSize: "35px"
	          }),
	          _react2.default.createElement(_TextList2.default, {
	            id: "list-taxidi",
	            fontSize: "25px",
	            list: ["Ταξίδι φαντασίας", "Ταξίδι μυθοπλασίας", "\u03A4\u03B1\u03BE\u03AF\u03B4\u03B9 \u03C3\u03C4\u03BF \"\u03C0\u03B1\u03C1\u03B5\u03BB\u03B8\u03CC\u03BD\" \u03B1\u03BB\u03BB\u03AC \u03BA\u03B1\u03B9 \u03C3\u03C4\u03BF \u03BC\u03AD\u03BB\u03BB\u03BF\u03BD", "Ταξίδι στον κόσμο της τέχνης", "Ταξίδι στον χώρο των επιστημών..."],
	            color: "#550055"
	          }),
	          _react2.default.createElement(_TypingText2.default, {
	            number: 1,
	            fontSize: "24px",
	            content: "Το Νηπιαγωγείο είναι αγάπη, εμπιστοσύνη, ασφάλεια, χαρά.",
	            color: "#550055"
	          }),
	          _react2.default.createElement(_TypingText2.default, {
	            number: 2,
	            fontSize: "40px",
	            content: "Το Νηπιαγωγείο είναι",
	            color: "#550055"
	          }),
	          _react2.default.createElement(
	            "g",
	            { transform: "scale(.8) translate(270, 310)" },
	            _react2.default.createElement(_Logo2.default, { id: "animated-logo" })
	          )
	        ),
	        _react2.default.createElement(_AnimationControls2.default, { color: "burgundy" })
	      )
	    );
	  };
	
	  return Nip;
	}(_react.Component);
	
	exports.default = Nip;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-nhpiagwgeio-js-fd8eccc75468e323fdff.js